export default {
      id: "Exit-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Exit",
      toString: function () {
        return this.url;
      }
    }